import React, { useEffect, useState, useTransition } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { POST_CALLTO_CCLS } from "../../../../services";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IconArrowCircleForward } from "@veneer/core";
import { apiPost } from "../../../../services/service";
import "./more-support-options.scss";
import { useTranslation } from "react-i18next";

interface ProductInfoProps {
  name?: string;
  version?: string;
  description?: string;
}

interface MoreSupportOptionsProps {
  productInfo: ProductInfoProps;
  urlInfo: any;
}

function MoreSupportOptions(MoreSupportOptionsProps: any) {
  const [data, setData] = useState<any>([]);
  const [enabledChat, setEnabledChat] = useState<boolean>(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const  noImage = require ("@assets/icons/image.png");
  const callMeIcon = require("@assets/icons/call.png")
  const agentIcon = require("@assets/icons/agent.png");
  const communityIcon = require("@assets/icons/community.png");
  const {t} = useTranslation();

  useEffect(() => {
    const OptionData = async () => {
      try {
        let payload = {
          Offset: -330,
          cid: searchParams.get("cid"),
          contactid: "85680C15-7814-E711-80FC-5065F38AD971",
          
          
        };
        const MoreOption = await apiPost(POST_CALLTO_CCLS, payload);
        if (MoreOption?.data?.cclsResponse) {
          let cclsResponses = JSON.parse(MoreOption.data.cclsResponse);
          if (cclsResponses?.ContactOptions) {
            console.log(`Sequence Number `,cclsResponses?.Sequence);
            let items = cclsResponses.ContactOptions;
            setData(items);
          }
        }
      } catch (error) {}
    };
    OptionData();
  }, []);
  const getServiceDesc = (type: number, keyName: string) => {
    //const service = data.find((item: any) => item.serviceType === type);
    const service = data.find((item: any) => {
        if (item.serviceType === type) {
            if (item.serviceType === 55 && item.openStatus !== "True") {
                return false;
            }
        return true; // Correct: `.find()` expects a boolean return.
      }
      return false;
    });
    return service ? service[keyName] :  "" ;
  };
  const getServiceDescOrwhDesc = (type: number, keyName: string) => {
    let service:any = "";
    for (let i = 0; i < data.length; i++) {
      const item = data[i];

      if (item.serviceType === type) {
        if(item.openStatus === "True") {
          service= item[keyName];
        }else{
          service = t('HPI.EditCase.MoreSupport.CurrentlyUnavailable',{defaultValue:'This option is currently unavailable. Please come back during the hours listed below'});
          service += '<br/>'
          service += item["whDesc"]!== null ? item["whDesc"] : "Monday through Friday 8:00 AM - 6:00 PM (Excluding public holidays).";
        }
        break;
      }
    }
    return service ;
  };

  const checkServiceAvailability = (type: number) => {
    if(data.length === 0) return false;
    const service = data.find((item: any) => item.serviceType === type);
    return service ? service.serviceType === 55 : false;
  };

  const callMeBack = () => {
    let uri = `cid=${searchParams.get("cid")}&ainfo=${
      MoreSupportOptionsProps?.urlInfo?.ainfo
    }&pno=${MoreSupportOptionsProps?.urlInfo?.pno}`;
    navigate(`/edit-case/call-me-back?${uri}`);
  };
  return (
    <div className="more-support-container">
      <Row className="support-cord">
        {checkServiceAvailability(55) && (
        <Col md={4}>
          <div>
            <img src={callMeIcon} className="ico" />
          </div>
          <Container fluid className="cord1">
            <p className="fonthead">{t('HPI.EditCase.Case.HPCallMe',{defaultValue:'Call Me Back'})}</p>
            <p className="cordfont">
              <span dangerouslySetInnerHTML={{ __html: getServiceDescOrwhDesc(55, "serviceDesc") }}></span>
            </p>
            <a
              target="__blank"
              href="https://www.hp.com/us-en/privacy/privacy.html"
              className="cordfont"
            >
              HP Privacy Statement
            </a>
            <div className="arrow">
              {getServiceDesc(55, "serviceDesc") === "" ? (
                // <IconArrowCircleForward
                //   color={"#0096d6"}
                //   size={30}
                //   disabled
                //   className="mt-2"
                // />
                <span> </span>
              ) : (
                <IconArrowCircleForward
                  filled={true}
                  onClick={callMeBack}
                  color={"#0096d6"}
                  size={30}
                  className="mt-2 img"
                />
              )}
            </div>
          </Container>
        </Col>
      )}
        <Col md={4}>
          <div>
            {" "}
            <img alt="" src={agentIcon} className="ico" />
          </div>
          <Container fluid className="cord2">
            <p className="fonthead">{t('HPI.EditCase.Case.SpeaktoAnAgent',{defaultValue:'Speak to an agent'})}</p>
            <p className="cordfont1">{t('HPI.EditCase.Case.AvailableNow',{defaultValue:'Available Now'})}</p>
            <p className="cordfont">{getServiceDesc(3, "serviceDesc")}</p>
            <p className="cordfont">{getServiceDesc(3, "whDesc")}</p>
            <p className="cordfont">
              {getServiceDesc(3, "PhoneGroups")?.[0]?.Phone}
            </p>
          </Container>
        </Col>
        <Col md={4}>
          <div>
            <img alt="" src={communityIcon} className="ico" />
          </div>
          <Container fluid className="cord3">
            <p className="fonthead">{t('HPI.EditCase.Case.HpSupportCommunity',{defaultValue:'HP Support Community'})}</p>
            <p className="cordfont">{getServiceDesc(10, "serviceDesc")}</p>
            <a
              target="__blank"
              href="https://www.hp.com/us-en/privacy/privacy.html"
              className="cordfont"
            >
              {t('HPI.EditCase.Case.ClickHere',{defaultValue:'Click Here'})}
            </a>
          </Container>
        </Col>
      </Row>
    </div>
  );
}
// }

export default MoreSupportOptions;
